// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-header[data-v-abe4f33e]{background-color:#bcbfcc!important;border-radius:5px;margin-bottom:15px;color:#fff}.referrer-logo[data-v-abe4f33e]{width:100px;margin-top:15px}", ""]);
// Exports
module.exports = exports;
